import { render, staticRenderFns } from "./KlineQuery.vue?vue&type=template&id=85c63d28&scoped=true"
import script from "./KlineQuery.vue?vue&type=script&lang=js"
export * from "./KlineQuery.vue?vue&type=script&lang=js"
import style0 from "./KlineQuery.vue?vue&type=style&index=0&id=85c63d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c63d28",
  null
  
)

export default component.exports